/**
 * service for all API calls for queries
 * @type {service}
 */
var queriesService = (function($, util){

  /**
   * Delete the given id
   * @param  {integer} id the id of the query
   * @return {ajax object}    returns the function
   */
  var deleteQuery = function(id){
    return $.ajax({
        url: util.createEndPoint(API_QUERIES_DELETE, {"id":id}),
        type: 'DELETE'
    });
  };

  /**
   * get a list of queries by type [news, reports]
   * @param  {string} type the type of the list of queries
   * @return {ajax object}    returns the function
   */
  var getQueryList = function(type){
    return $.ajax({
        url: util.createEndPoint(API_QUERIES_DELETE, {"type":type}),
        type: 'GET'
    });
  };

  return {
    deleteQuery: deleteQuery,
    getQueryList: getQueryList
  };

}(jQuery, serviceUtil));

define("components/services/queries", function(){});

